import { Pipette } from '@wix/wix-ui-icons-common';
import PropTypes from 'prop-types';
import React from 'react';
import Box from '../Box';
import SegmentedToggle from '../SegmentedToggle';
import ToggleButton from '../ToggleButton';
import { classes, st } from './ColorPickerConverter.st.css';
import ColorPickerConverterHex from './ColorPickerConverterHex';
import ColorPickerConverterHsb from './ColorPickerConverterHsb';
import ColorPickerConverterRGB from './ColorPickerConverterRGB';
import { safeColor } from './utils';
import { EyeDropper } from './ColorPickerEyeDropper';
import { DataHooks } from './constants';

const HEX = 'HEX';
const RGB = 'RGB';
const HSB = 'HSB';

export default class ColorPickerConverter extends React.PureComponent {
  static propTypes = {
    current: PropTypes.object.isRequired,
    showConverter: PropTypes.bool.isRequired,
    showInput: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onEnter: PropTypes.func.isRequired,
    onAdd: PropTypes.func,
    allowEmpty: PropTypes.bool,
    hexPlaceholder: PropTypes.string,
    showEyeDropper: PropTypes.bool,
    eyeDropperLabel: PropTypes.string,
  };

  state = {
    activeConverter: HEX,
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {
      dataHook,
      current,
      showConverter,
      showInput,
      addTooltipContent,
      allowEmpty,
      hexPlaceholder,
      showEyeDropper,
      eyeDropperLabel,
    } = this.props;
    const dataHooks = {
      hex: 'color-picker-hex-input',
      rgb: 'color-picker-rgb-inputs',
      hsb: 'color-picker-hsb-inputs',
    };
    const { activeConverter } = this.state;

    if (!showConverter && !showInput) {
      return null;
    }

    if (!showConverter) {
      return (
        <Box direction="horizontal" gap="small" align="center">
          {showEyeDropper && (
            <EyeDropper
              eyeDropperLabel={eyeDropperLabel}
              allowEmpty={allowEmpty}
              onChange={this.props.onChange}
            />
          )}
          <ColorPickerConverterHex
            placeholder={hexPlaceholder}
            dataHook={dataHooks.hex}
            current={current}
            onChange={this.props.onChange}
            onEnter={this.props.onEnter}
            onAdd={this.props.onAdd}
            addTooltipContent={addTooltipContent}
            allowEmpty={allowEmpty}
          />
        </Box>
      );
    }

    return (
      <div className={st(classes.root)} data-hook={dataHook}>
        <div className={st(classes.colorModelSwitcher)}>
          <SegmentedToggle
            selected={activeConverter}
            onClick={(evt, value) => this.changeConverter(evt, value)}
            size="medium"
          >
            <SegmentedToggle.Button
              value={HEX}
              dataHook={DataHooks.hexConverterBtn}
            >
              {HEX}
            </SegmentedToggle.Button>
            <SegmentedToggle.Button
              value={RGB}
              dataHook={DataHooks.rgbConverterBtn}
            >
              {RGB}
            </SegmentedToggle.Button>
            <SegmentedToggle.Button
              value={HSB}
              dataHook={DataHooks.hsbConverterBtn}
            >
              {HSB}
            </SegmentedToggle.Button>
          </SegmentedToggle>
          {showEyeDropper && (
            <EyeDropper
              eyeDropperLabel={eyeDropperLabel}
              allowEmpty={allowEmpty}
              onChange={this.props.onChange}
            />
          )}
        </div>

        {activeConverter === HEX && (
          <ColorPickerConverterHex
            placeholder={hexPlaceholder}
            dataHook={dataHooks.hex}
            current={current}
            onChange={this.props.onChange}
            onAdd={this.props.onAdd}
            onEnter={this.props.onEnter}
            addTooltipContent={addTooltipContent}
            allowEmpty={allowEmpty}
          />
        )}
        {activeConverter === RGB && (
          <ColorPickerConverterRGB
            dataHook={dataHooks.rgb}
            current={current}
            onChange={this.props.onChange}
            onAdd={this.props.onAdd}
            addTooltipContent={addTooltipContent}
            allowEmpty={allowEmpty}
          />
        )}
        {activeConverter === HSB && (
          <ColorPickerConverterHsb
            dataHook={dataHooks.hsb}
            current={current}
            onChange={this.props.onChange}
            onAdd={this.props.onAdd}
            addTooltipContent={addTooltipContent}
            allowEmpty={allowEmpty}
          />
        )}
      </div>
    );
  }

  changeConverter = (evt, value) => {
    this.setState({ activeConverter: value });
  };
}
